// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { SigninOption, ReturnToApplication, FederatedIdProvider, UserAccount } = initSchema(schema);

export {
  SigninOption,
  ReturnToApplication,
  FederatedIdProvider,
  UserAccount
};